import React from 'react';
import { Box, Skeleton, Container } from '@mui/material';

const PageSkeleton = () => {
  return (
    <Container maxWidth="lg" sx={{ py: 6 }}>
      <Skeleton variant="text" height={60} width="40%" sx={{ mb: 3 }} />
      <Skeleton variant="rectangular" height={220} sx={{ mb: 4, borderRadius: 3 }} />
      <Skeleton variant="text" height={28} width="70%" />
      <Skeleton variant="text" height={28} width="65%" />
      <Skeleton variant="text" height={28} width="60%" />

      <Box sx={{ display: 'flex', gap: 3, mt: 5 }}>
        {[1, 2, 3].map((i) => (
          <Skeleton
            key={i}
            variant="rectangular"
            width="100%"
            height={180}
            sx={{ borderRadius: 3 }}
          />
        ))}
      </Box>
    </Container>
  );
};

export default PageSkeleton;
